<template>
  <div class="schedule_address" >
    <el-divider content-position="left">服务地点列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入地点名称"
        size="mini"
        clearable
        :remote-method="searchRemotePlace"
        :loading="searchLoading"
        @change="handleSearchPlace"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.places_title"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="placeForm"
          :rules="rules"
          ref="placeForm"
          label-width="100px"
        >
          <el-form-item label="地点名称" prop="places_title">
            <el-input v-model="placeForm.places_title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="区域" prop="area_id">
            <el-select
              v-model="placeForm.area_id"
              placeholder="请选择"
              size="mini"
              @click.native="loadArea"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in areaOptions"
                :key="item.id"
                :label="item.areaName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="坐标x" prop="coordinate_x">
            <el-input size="mini" v-model="placeForm.coordinate_x"></el-input>
          </el-form-item>
          <el-form-item label="坐标y" prop="coordinate_y">
            <el-input size="mini" v-model="placeForm.coordinate_y"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              size="mini"
              type="textarea"
              v-model="placeForm.address"
            ></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('placeForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="placeForm"
          :rules="rules"
          ref="placeForm"
          label-width="100px"
        >
          <el-form-item label="地点名称" prop="places_title">
            <el-input v-model="placeForm.places_title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="区域" prop="area_id">
            <el-select
              v-model="placeForm.area_id"
              placeholder="请选择"
              size="mini"
              @click.native="loadArea"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in areaOptions"
                :key="item.id"
                :label="item.areaName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="坐标x" prop="coordinate_x">
            <el-input size="mini" v-model="placeForm.coordinate_x"></el-input>
          </el-form-item>
          <el-form-item label="坐标y" prop="coordinate_y">
            <el-input size="mini" v-model="placeForm.coordinate_y"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              size="mini"
              type="textarea"
              v-model="placeForm.address"
            ></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('placeForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      max-height="650"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="places_title" label="地点名称"> </el-table-column>
      <el-table-column prop="area.areaName" label="区域"> </el-table-column>
      <el-table-column prop="coordinate_x" label="坐标x"> </el-table-column>
      <el-table-column prop="coordinate_y" label="坐标y"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="nowPage"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScheduleCate',
  data () {
    return {

      searchArr: {
        category_id: ''
      },
      adminUserOptions: [],
      adminRoleOptions: [],
      npage: 1,
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      areaOptions: [],
      category: '',
      nowPage: 1,
      placeForm: {
        places_title: '',
        area_id: '',
        coordinate_x: '',
        coordinate_y: '',
        address: ''
      },
      editCategoryForm: {
        categoryId: '',
        category_name: '',
        display: false,
        incharge_id: '',
        exec_role: '',
        desc: ''
      },
      rules: {
        places_title: [
          { required: true, message: '请输入地点', trigger: 'blur' }
        ],
        area_id: [{ required: true, message: '请选择区域', trigger: 'blur' }],
        coordinate_x: [
          { required: true, message: '请输入坐标', trigger: 'blur' },
          { max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' }
        ],
        coordinate_y: [
          { required: true, message: '请输入坐标', trigger: 'blur' },
          { max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' }
        ],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
  methods: {
    loadTable () {
      this.$axios
        .get(
          'api/servicein/getaddress?page=' +
            this.npage +
            '&perpage=' +
            this.categoryPerPage,
          {
            params: {
              place_id: this.searcher
            }
          }
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
          }
        })
        .catch()
    },
    loadRadio () {
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.$axios
        .get('api/servicein/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.areaOptions = [data.data.area]
            this.placeForm = data.data
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    searchRemotePlace (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/servicein/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchPlace (query) {
      this.searcher = query
      this.npage = 1
      this.nowPage = 1
      this.loadTable()
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$refs.placeForm.resetFields()
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/servicein/placestore', this.placeForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.$refs.placeForm.resetFields()
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/servicein/edit', this.placeForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.$refs.placeForm.resetFields()
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/servicein/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/servicein/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadAdminUser () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data
          }
        })
        .catch()
    },
    loadAdminRole () {
      this.$axios
        .get('api/servicein/getrole')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminRoleOptions = data.data
          }
        })
        .catch()
    },
    loadArea () {
      this.$axios
        .get('api/servicein/getarea')
        .then(({ data }) => {
          if (data.code === 1) {
            this.areaOptions = data.data
          }
        })
        .catch()
    }
  }
}
</script>
<style scoped>
.schedule_address {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/schedule/ScheduleAddress.vue